/**
 * Ambient Background Animation System
 * Adheres to Custom Namespacing and GPU Performance rules
 */
function initAmbientBackground() {
  // Check for reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  const bgContainer = document.querySelector("[data-gsap='ambient-background']")
  if (!bgContainer) return

  const glow1 = bgContainer.querySelector('.glow-1')
  const glow2 = bgContainer.querySelector('.glow-2')

  // Safety check: Ensure GSAP actually loaded before trying to animate
  if (typeof gsap === 'undefined') {
    console.warn('GSAP is not defined yet.')
    return
  }

  // Clear previous animations to prevent duplicate initialization [cite: 69]
  gsap.killTweensOf([glow1, glow2])

  // FAST TEST DURATIONS: Set to 2 seconds just so you can see it move!
  // Once you confirm it works, change duration back to 25-30 for the luxury feel.
  gsap.to(glow1, {
    x: '15vw',
    y: '10vh',
    scale: 1.1,
    duration: 30,
    repeat: -1,
    yoyo: true,
    ease: 'sine.inOut',
  })

  gsap.to(glow2, {
    x: '-10vw',
    y: '-15vh',
    scale: 0.9,
    duration: 35,
    repeat: -1,
    yoyo: true,
    ease: 'sine.inOut',
  })
}

// Bulletproof initialization that accounts for 'defer' loading
function runSafeInit() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAmbientBackground)
  } else {
    initAmbientBackground() // DOM is already ready, run immediately
  }
}

// Initialize on page load
runSafeInit()

// Rebuild animations safely after Shopify Theme Editor updates [cite: 61, 68]
document.addEventListener('shopify:section:load', initAmbientBackground)
